module.exports = __webpack_public_path__ + "static/media/demo4.281aa89a.png";